import React, { useState, useEffect, useRef } from "react";
import Button from "./Button";
import Icon from "./Icon";

const TextField = React.forwardRef(({
  value = "",
  autoFocus,
  onChange,
  disabled,
  search,
  className,
  onClick,
  style,
  leading,
  label,
  placeholder,
  maxLength,
  reset,
  trailing,
  support,
  type = "text",
  ...rest
}, ref) => {
  const [inputValue, setInputValue] = useState(value || "");
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    if (autoFocus) {
      inputRef.current && inputRef.current.focus();
    }
  }, [autoFocus]);

  useEffect(() => {
    if (inputValue !== value && value !== undefined) {
      setInputValue(value);
    }
  }, [value]);

  useEffect(() => {
    if (inputValue !== value && onChange) {
      onChange(inputValue);
    }
  }, [inputValue]);

  const classes = [
    "ta-textfield",
    disabled && "ta-is-disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleChange = (event) => {
    if (!disabled) {
      setInputValue(event.target.value);
    }
  };

  return (
    <div
      ref={ref}
      onClick={onClick}
      tabIndex="-1"
      onFocus={(e) => {
        setIsFocused(true);
      }}
      onBlur={(e) => {
        // Only blur if relatedTarget is not inside the current component (bubbling check)
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setIsFocused(false);
        }
      }}
      className={classes}
      style={style}
      data-populated={inputValue !== "" ? "true" : undefined}
      data-focused={isFocused ? "true" : undefined}
      data-search={search ? "true" : undefined}
      {...rest}
    >
      <div className="ta-textfield_field">
        {leading && (
          <Icon symbol={leading} className="ta-textfield_symbol" />
        )}
        {label && (
          <label className={"ta-textfield_label "}>{label} </label>
        )}
        {search && (
          <Icon
            symbol="search"
            className="ta-color-text_on-surface-variant ta-margin_leftright-xs"
          />
        )}
        <input
          ref={inputRef}
          onChange={(e) => handleChange(e)}
          type={type}
          value={inputValue}
          placeholder={placeholder}
          className="ta-textfield_input"
          maxLength={maxLength}
          disabled={disabled}
        />
        {reset && inputValue !== "" && !disabled && (
          <Button
            className="ta-textfield_clear "
            icon
            symbol="cancel"
            onClick={() => setInputValue("")}
          />
        )}
        {trailing && (
          <Icon
            symbol={trailing}
            className="ta-color-text_on-surface-variant ta-margin_right-xxs"
          />
        )}
      </div>
      {support && (
        <div className="ta-textfield_support">{support}</div>
      )}
    </div>
  );
});

export default TextField;
